import { useState } from 'react'
import PropTypes from 'prop-types'

import ImageField from '../../FormLegacy/FormFieldsV2/ImageField'
import Icon from '../../Icons'

const AnswerImagePicker = ({ answer, question, onInputChange }) => {
  const [images, setImages] = useState([])
  const imageLimit = question.imageLimit ? question.imageLimit : 3

  const pickImage = (question, answer, val) => {
    const newImages = [...images, val]
    setImages(newImages)
    onInputChange(question, answer, newImages)
  }

  const removeImage = (index) => {
    const newImages = [...images]
    newImages.splice(index, 1)
    setImages(newImages)
    onInputChange(question, answer, newImages)
  }

  return (
    <div key={answer.customId} className="answer-image-picker">
      <div className="all-images-container">
        {images.length > 0
          ? images.map((image, index) => (
              <div className="image-container" key={image.name}>
                <div className="trash-wrap" onClick={() => removeImage(index)}>
                  <Icon icon={'trash'} className="small-image-trash" />
                </div>
                <img src={image.image} />
              </div>
            ))
          : null}
      </div>
      {images.length < imageLimit ? (
        <div className="pick-image">
          <ImageField
            name={'imageWrapper'}
            imageRatio={1}
            value={{}}
            onChange={(e) => pickImage(question, answer, e.target.value)}
          />
        </div>
      ) : null}
    </div>
  )
}

AnswerImagePicker.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object,
  onInputChange: PropTypes.func,
}

export default AnswerImagePicker
